// extracted by mini-css-extract-plugin
module.exports = {"emptyCard":"emptyCard___1KNLG","img":"img___3y9i5"};